const ChipStyles = () => ({
  backgroundColor: '#e3f6ff'
});

export default ChipStyles;
